// Henry Schein Dental En
import Gold_US_en from 'assets/img/gold-horizontal.jpg';
import Silver_US_en from 'assets/img/logo-silver-hor.jpg';
import Platinum_US_en from 'assets/img/platinum-horizontal.jpg';
import Bronze_US_en from 'assets/img/bronze-horizontal.jpg';
import ThriveLogo_US_en from 'assets/img/thrive-logo.png';
import HSBanner_en from 'assets/img/Banner-Image.png';
import Gold_Sidebar_Logo_US_en from 'assets/img/Gold_wword_Gold.png';
import Silver_Sidebar_Logo_US_en from 'assets/img/Silver_wword_Silver.png';
import Platinum_Sidebar_Logo_US_en from 'assets/img/Platinum_wword_Platinum.png';
import Bronze_Sidebar_Logo_US_en from 'assets/img/BronzeFuschia_wwords_Bronze.png';
import Congratulations_EN from "assets/img/Congradulations.png";
import Newbanner from 'assets/img/new banner.jpg';
import Newbanners from 'assets/img/new banners.jpg';
import Newthrive from 'assets/img/newthrive.jpg';
import Newsignature from 'assets/img/newsignature.jpg';

// ---------------------------------- NEW BANNER------------
import NewBronze from 'assets/img/Bronze new.png';
import NewSilver from 'assets/img/Silver.png';
import NewPlatinum from 'assets/img/Platinum new.png';
import NewGold from 'assets/img/Gold  new.png';
import Newsignaturebronze from 'assets/img/Thrive-Signature-Bronze.png';
import Newsignaturegold from 'assets/img/Thrive-Siganture-Gold.png';
import Newsignaturesilver from 'assets/img/Thrive-Signature-Silver.png';
import Newsignatureplatinum from 'assets/img/Thrive-Signature-Platinum.png';
import Newheader from 'assets/img/Thrive Rewards_HS Lockup.png';
import NewCongrulations from 'assets/img/Congratulations new.png';
import Newsignaturelogo from 'assets/img/Signaturenewone.png';
import Startuplogo from 'assets/img/startuplogo.png';
import NewElite from 'assets/img/elite logo.png';
import NewSelect from 'assets/img/select logo.png';
import NewCore from 'assets/img/core logo.png';






// Henry Schein Canada En
import GoldCA_en from 'assets/img/gold-horizontal.jpg';
import SilverCA_en from 'assets/img/logo-silver-hor.jpg';
import PlatinumCA_en from 'assets/img/platinum-horizontal.jpg';
import BronzeCA_en from 'assets/img/bronze-horizontal.jpg';
import ThriveLogoCA_en from 'assets/img/thrive-logo.png';
import CABanner_en from "assets/img/Banner-Image.png";
import Gold_Sidebar_Logo_CA_en from 'assets/img/Gold  new.png';
import Silver_Sidebar_Logo_CA_en from 'assets/img/Silver.png';
import Platinum_Sidebar_Logo_CA_en from 'assets/img/Platinum new.png';
import Bronze_Sidebar_Logo_CA_en from 'assets/img/Bronze new.png';

// Henry Schein Canada Fr
import GoldCA_fr from 'assets/img/header_gold_logo_fr.png';
import SilverCA_fr from 'assets/img/header_logo_silver_fr.png';
import PlatinumCA_fr from 'assets/img/header_logo_platinum_fr.png';
import BronzeCA_fr from 'assets/img/header_logo_bronze_fr.png';
import ThriveLogoCA_fr from 'assets/img/header_logo_no_tier_fr.png';
import CABanner_fr from 'assets/img/HS_Banner_Fr.jpg';
// import Gold_Sidebar_Logo_CA_fr from 'assets/img/Or_FR.png';
// import Silver_Sidebar_Logo_CA_fr from 'assets/img/Silver-Argent_FR.png';
// import Platinum_Sidebar_Logo_CA_fr from 'assets/img/Platinum-Platine_FR.png';
// import Bronze_Sidebar_Logo_CA_fr from 'assets/img/Bronze-Bronze_FR.png';
import Congratulations_CA_fr from 'assets/img/Congratulations_Colorful_FR.png';
import Gold_Sidebar_Logo_CA_fr from 'assets/img/gold-fr-new.png';
import Silver_Sidebar_Logo_CA_fr from 'assets/img/silver-fr-new.png';
import Platinum_Sidebar_Logo_CA_fr from 'assets/img/platinum-fr-new.png';
import Bronze_Sidebar_Logo_CA_fr from 'assets/img/bronze-fr-new.png';


import NonSigBannerUsEn from 'assets/img/NonSigBannerUsEn.jpg';
import NonSigBannerCaEn from 'assets/img/NonSigBannerUsEn.jpg';
import NonSigBannerCaFr from 'assets/img/NonSigBannerUsEn.jpg';
import SigBannerUsEn from 'assets/img/SigBannerUsEn.jpg';
import SigBannerCaEn from 'assets/img/SigBannerUsEn.jpg';
import SigBannerCaFr from 'assets/img/SigBannerUsEn.jpg';
import SigLogoUsEn from 'assets/img/SigLogoUsEn.png';
import SigLogoCaEn from 'assets/img/SigLogoUsEn.png';
import SigLogoCaFr from 'assets/img/SigLogoUsEn.png';
import Warning from 'assets/img/warning.png';



export const imageHandler = {
    "Henry Schein Dental": {
        "en": {
            "banner": HSBanner_en,
            "bannerNonSig": Newbanners,
            "bannerSig":Newbanners,
            "SignatureSidebarLogo": SigLogoUsEn,
            "BronzeSidebarLogo": Bronze_Sidebar_Logo_US_en,
            "SilverSidebarLogo": Silver_Sidebar_Logo_US_en,
            "GoldSidebarLogo": Gold_Sidebar_Logo_US_en,
            "PlatinumSidebarSignatureLogo": Newsignatureplatinum,
            "BronzeSidebarSignatureLogo": Newsignaturebronze,
            "SilverSidebarSignatureLogo": Newsignaturesilver,
            "GoldSidebarSignatureLogo": Newsignaturegold,
            "PlatinumSidebarLogo": Platinum_Sidebar_Logo_US_en,
            "BronzeHeaderLogo": Bronze_US_en,
            "SilverHeaderLogo": Silver_US_en,
            "GoldHeaderLogo": Gold_US_en,
            "PlatinumHeaderLogo": Platinum_US_en,
            "nullHeaderLogo": ThriveLogo_US_en,
            "congratulationLogo": Congratulations_EN,
            "warning":Warning,
            "BronzeSidebarLogoNew":NewBronze,
            "GoldSidebarLogoNew":NewGold,
            "SilverSidebarLogoNew":NewSilver,
            "PlatinumSidebarLogoNew":NewPlatinum,
            "Newheader":Newheader,
            "NewCongrulations":NewCongrulations,
            "Newsignaturelogo":Newsignaturelogo,
            "Startuplogo":Startuplogo,
            "EliteSidebarLogoNew":NewElite,
            "SelectSidebarLogoNew":NewSelect,
            "CoreSidebarLogoNew":NewCore,
           
            

        },
    },
    "Henry Schein Canada": {
        "en": {
            "banner": CABanner_en,
            "bannerSig": SigBannerCaEn,
            "bannerNonSig": NonSigBannerCaEn,
            "SignatureSidebarLogo": SigLogoCaEn,
            "BronzeSidebarLogo": Bronze_Sidebar_Logo_CA_en,
            "SilverSidebarLogo": Silver_Sidebar_Logo_CA_en,
            "GoldSidebarLogo": Gold_Sidebar_Logo_CA_en,
            "PlatinumSidebarLogo": Platinum_Sidebar_Logo_CA_en,
            "BronzeHeaderLogo": BronzeCA_en,
            "SilverHeaderLogo": SilverCA_en,
            "GoldHeaderLogo": GoldCA_en,
            "PlatinumHeaderLogo": PlatinumCA_en,
            "nullHeaderLogo": ThriveLogoCA_en,
            "congratulationLogo": Congratulations_EN
        },
        "fr": {
            "banner": CABanner_fr,
            "bannerNonSig": NonSigBannerCaFr,
            "bannerSig": SigBannerCaFr,
            "SignatureSidebarLogo": SigLogoCaFr,
            "BronzeSidebarLogo": Bronze_Sidebar_Logo_CA_fr,
            "SilverSidebarLogo": Silver_Sidebar_Logo_CA_fr,
            "GoldSidebarLogo": Gold_Sidebar_Logo_CA_fr,
            "PlatinumSidebarLogo": Platinum_Sidebar_Logo_CA_fr,
            "BronzeHeaderLogo": BronzeCA_fr,
            "SilverHeaderLogo": SilverCA_fr,
            "GoldHeaderLogo": GoldCA_fr,
            "PlatinumHeaderLogo": PlatinumCA_fr,
            "nullHeaderLogo": ThriveLogoCA_fr,
            "congratulationLogo": Congratulations_CA_fr
        }
    }
}